import React, { Component } from 'react'
import {
	Form,
	Row,
	Col,
	Input, InputNumber, Select, Checkbox, Radio,
	Button, Table, Popconfirm, Modal,
	Icon, Card, Tag,
	Collapse
} from 'antd';
import { uuid } from '../../common/CommonFunc'
import { UserModal } from '../../common/UserModal'
import  PubInfo  from '../../Component/PubInfo'
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
let jsPicture = require('../images/jsExample.png')
let javaPicture = require('../images/javaExample.png')





class ScriptNodeFrom extends Component {

	constructor(props) {
		super(props)

		this.state = {
			node: props.node,
			show: props.show != null && props.show == true ? props.show : 'none',
			nodedata: props.nodedata,
			modalinShow: false,
			modaloutShow: false,
			loading: false,
			switch: false
		}
	}

	// 重新加载页面方法
	reload = () => {
		this.setState({ loading: false });
	}
	// 展示示例按钮点击事件
	buttonOnChange(attname, e, e2) {
		tool.sgiLogger.log("事件：buttonOnChange")
		this.setState({
			switch: !this.state.switch
		});

	}





	// 文本修改事件
	textOnChange(attname, e, e2) {
		tool.sgiLogger.log("事件：textOnChange")
		let value = e.target.value;
		this.refresh(attname, value);
	}
	// 下拉窗修改事件
	selectOnChange = (attname, value) => {//change传入对象为value
		tool.sgiLogger.log("事件：selectOnChange")
		this.refresh(attname, value);
	}
	// 复选框组修改事件，checkedValue为数组["01","02"]
	checkboxGroupOnChange = (attname, checkedValue) => {
		tool.sgiLogger.log("事件：checkboxGroupOnChange")
		this.refresh(attname, checkedValue);
	}
	// 数字组件修改事件
	numberOnChange(attname, e) {
		tool.sgiLogger.log("事件：numberOnChange")
		let value = e;
		this.refresh(attname, value);
	}
	// 单选框组修改事件
	radioGroupOnChange(attname, e) {
		tool.sgiLogger.log("事件：radioGroupOnChange")
		let value = e.target.value;
		this.refresh(attname, value);
	}
	// 属性更新
	refresh(attname, value) {
		if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
		this.state.nodedata[attname] = value;
	}
	// 输入参数modal确认按钮事件
	scriptcallinHandleOk = (e) => {
		const { scriptcallin } = this.state.nodedata;
		const newData = {
			inParamKey: this.state.inParamKey,
			inParamValue: this.state.inParamValue,
		};
		this.state.nodedata.scriptcallin = [...scriptcallin, newData]
		this.state.modalinShow = false;
		this.setState({
			loading: false,
		});
	}
	// 输出参数modal确认按钮事件
	scriptcalloutHandleOk = (e) => {
		const { scriptcallout } = this.state.nodedata;
		const newData = {
			outParamKey: this.state.outParamKey,
			outParamValue: this.state.outParamValue,
		};
		this.state.nodedata.scriptcallout = [...scriptcallout, newData]
		this.state.modaloutShow = false;
		this.setState({
			loading: false,
		});
	}
	// 输入参数modal取消按钮事件
	modalHandleCancel = (e) => {
		this.setState({
			modalinShow: false,
			modaloutShow: false
		});
	}
	// modal中文本框修改事件
	modalOnChange = (attname, e, e2) => {
		tool.sgiLogger.log("事件：modalOnChange")
		let value = e.target.value;
		this.state[attname] = value;
	}
	// 创建表格绑定store（生成数据key）
	getTBData = (tData) => {
		if (!tData) {
			tData = [];
			return tData;
		}
		tData.forEach(element => {
			if (!element._key) element._key = uuid(8);
		})
		return tData;
	}
	// 刷新form
	componentDidMount() {
		tool.sgiLogger.log('事件：serviceNode加载后')
		this.props.form.setFieldsValue({

			scripttype: this.state.nodedata.scripttype,
			scriptcode: this.state.nodedata.scriptcode,
			scriptcallin: this.state.nodedata.scriptcallin,
			scriptcallout: this.state.nodedata.scriptcallout,
		});
	}
	// 表格添加方法
	handleAdd = (modalType) => {
		tool.sgiLogger.log("handleAdd表格添加方法");
		if (!modalType || modalType == '') {
			this.state.modalContent = null;;
		}
		if (modalType == "scriptcallin") {
			this.state.modalinShow = true;
		} else if (modalType == "scriptcallout") {
			this.state.modaloutShow = true;
		}
		this.setState({
			loading: false
		});

	}
	// 表格删除方法
	handleDelete = (delData, dataSource) => {
		if (dataSource && delData) {
			for (var i = 0; i < dataSource.length; i++) {
				if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
					dataSource.splice(i, 1);
				}
			}
		}
		this.setState({ loading: false });
	}
	render() {

		const { getFieldDecorator } = this.props.form;
		const scriptcallinList = this.getTBData(this.state.nodedata.scriptcallin);
		const scriptcallinListColumns = [
			{
				title: '输入参数key', // 列头显示名称
				dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输入参数值', // 列头显示名称
				dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.scriptcallin.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.scriptcallin)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];
		const scriptcalloutList = this.getTBData(this.state.nodedata.scriptcallout);
		const scriptcalloutListColumns = [
			{
				title: '输出参数key', // 列头显示名称
				dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
			},
			{
				title: '输出参数值', // 列头显示名称
				dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
			},
			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					this.state.nodedata.scriptcallout.length >= 1
						? (
							<Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.scriptcallout)}>
								<a href="javascript:;">删除</a>
							</Popconfirm>
						) : null
				),
			}
		];

		tool.sgiLogger.log(this.props);
		tool.sgiLogger.log(this.state.show);
		return (<div style={{ display: this.state.show }}>
			<Form layout="vertical" >
				<Collapse defaultActiveKey={['1']} >
					<Panel header="通用节点信息" key="1">
						<PubInfo parent={this} node={this.state.node} nodedata={this.state.nodedata} />
					</Panel>
					<Panel header="脚本节点信息" key="2">
						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="脚本类型">
									{getFieldDecorator('scripttype', {
										rules: [{ required: true, message: '请输入脚本类型' }],
									})(<RadioGroup onChange={this.radioGroupOnChange.bind(this, 'scripttype')} >
										<Radio value={"0"}>JavaScript</Radio>
										<Radio value={"1"}>JAVA</Radio>
									</RadioGroup>)}

								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={24}>
								<div align="right">
									<Button size="small" onClick={this.handleAdd.bind(this, "scriptcallin")} type="primary" style={{ marginBottom: 10 }}>
										添加脚本输入
										</Button>
								</div>
								<Table size="small" rowKey={"_key"}
									rowClassName={() => 'incomeList-row'} // 表格行的类名
									bordered // 是否展示外边框和列边框
									dataSource={scriptcallinList}
									columns={scriptcallinListColumns}
								/>
								<Modal
									title="添加脚本输入参数"
									visible={this.state.modalinShow}
									onOk={this.scriptcallinHandleOk.bind(this)}
									onCancel={this.modalHandleCancel}
									okText="确认"
									cancelText="取消"
									destroyOnClose
								>
									<Form.Item label="输入参数key">
										<Input placeholder="输入参数key"
											onChange={this.modalOnChange.bind(this, 'inParamKey')}
										/>
									</Form.Item>
									<Form.Item label="输入参数value">
										<Input placeholder="输入参数value"
											onChange={this.modalOnChange.bind(this, 'inParamValue')}
										/>
									</Form.Item>
								</Modal>
							</Col>
						</Row>

						<Row gutter={16}>
							<Col span={24}>
								<div style={{ color: "red" }}	>
									输出参数将保存在工作流的业务数据中
									</div>
								<div align="right">
									<Button size="small" onClick={this.handleAdd.bind(this, "scriptcallout")} type="primary" style={{ marginBottom: 10 }}>
										添加脚本输出
										</Button>
								</div>
								<Table size="small" rowKey={"_key"}
									rowClassName={() => 'incomeList-row'} // 表格行的类名
									bordered // 是否展示外边框和列边框
									dataSource={scriptcalloutList}
									columns={scriptcalloutListColumns}
								/>
								<Modal
									title="添加脚本输出参数"
									visible={this.state.modaloutShow}
									onOk={this.scriptcalloutHandleOk.bind(this)}
									onCancel={this.modalHandleCancel}
									okText="确认"
									cancelText="取消"
									destroyOnClose
								>
									<Form.Item label="输出参数key">
										<Input placeholder="输出参数key"
											onChange={this.modalOnChange.bind(this, 'outParamKey')}
										/>
									</Form.Item>
									<Form.Item label="输出参数value">
										<Input placeholder="输出参数value"
											onChange={this.modalOnChange.bind(this, 'outParamValue')}
										/>
									</Form.Item>
								</Modal>
							</Col>
						</Row>
						<Row gutter={16}>

							<Col span={24}>
								<Form.Item
									// label="脚本内容">
									label={
										<div style={{ width: 620 }}>
											脚本内容
										 <Button
												// size="small"
												style={{
													backgroundColor: "#1890ff",
													 color: "white",
													marginLeft: "76%"
												}}
												onClick={this.buttonOnChange.bind(this)}
												type="primary"											>
												{this.state.switch == true ? "收起示例" : "展示示例"}
											</Button>
										</div>
									}>

									{getFieldDecorator('scriptcode', {
										rules: [{ required: false, message: '请输入脚本内容' }],
									})(<Input.TextArea rows={10} placeholder="请输入脚本内容"
										onChange={this.textOnChange.bind(this, 'scriptcode')}
									/>)}
								</Form.Item>
							</Col>



							{this.state.nodedata.scripttype == "0" ?

								<Col span={24}>
									<Form.Item
										// label="示例"
										style={{ display: (this.state.switch == true ? undefined : "none") }}
									>
										<div style={{ fontWeight: 'bold', fontSize: 17, backgroundColor: "green", color: "white", textAlign: "center" }}	>
											示例
									</div>

										<div>
											<img
												style={{ width: "100%", height: "100%" }}
												src={jsPicture} />
										</div>

										<Input.TextArea readOnly={true} rows={10}
											value={"//获取输入参数时直接使用输入参数key\rvar e =inkeyone;\rvar f =inkeytwo;\rvar g =inkeythree;\r\r//输出参数\r//脚本中定义的所有变量名都可以作为输出参数的key\rvar a =1;\rvar b = \"str\";\rvar c = 3;"}
										/>
									</Form.Item>
								</Col>

								:

								<Col span={24}>
									<Form.Item
										// label="示例"
										style={{ display: (this.state.switch == true ? undefined : "none") }}
									>
										<div style={{ fontWeight: 'bold', fontSize: 17, backgroundColor: "green", color: "white", textAlign: "center" }}	>
											示例
									</div>

										<div>
											<img
												style={{ width: "100%", height: "100%" }}
												src={javaPicture} />
										</div>

										<Input.TextArea readOnly={true} rows={10} 
											value={"//从map中获取输入参数 \rObject getValueOne = map.get(\"inKeyOne\"); \rObject getValueTwo = map.get(\"inKeyTwo\");	\rObject getValueThree = map.get(\"inKeyThree\");\r\r//输出参数以key-value的形式放入map中	\r//输出内容为数字类型时,需要转换成Integer类型	\rjava.lang.Integer outPutValueOne = new java.lang.Integer(111);	\rmap.put(\"outKeyOne\",outPutValueOne );	\r\r//输出内容为字符串或对象类型时直接放入map中	\rmap.put(\"outKeyTwo\", \"www.baidu.com\");	\rmap.put(\"outKeyThree\",getValueThree );"}
										/>
									</Form.Item>
								</Col>
							}
						</Row>
					</Panel>
				</Collapse>
			</Form>
			{this.state.modalContent}
		</div>
		)
	}
}
const ScriptNode = Form.create()(ScriptNodeFrom);

export default ScriptNode;




// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/Component/ScriptNode.js